var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';
import { summaries } from "../../helper/util";
import ELogisticsType from "../../enum/ELogisticsType";
import MulShopOamount from "./MulShopOamount.vue";
import EOrderFromSystem from "../../enum/EOrderFromSystem";
import GLOBAL_VUE from '../../globalVue';
import SeeBindLicenses from '../good/SeeBindLicenses';
import SelectStockBatch from './component/SelectStockBatch';
var DeliverGoodTable = (function (_super) {
    __extends(DeliverGoodTable, _super);
    function DeliverGoodTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.eLogisticsType = ELogisticsType;
        _this.eOrderFromSystem = EOrderFromSystem;
        _this.mulShopList = [];
        _this.currentGood = {};
        return _this;
    }
    DeliverGoodTable.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 325;
        }, 300);
    };
    DeliverGoodTable.prototype.selectStockBatch = function (row) {
        this.$refs.SelectStockBatch.show(row);
    };
    DeliverGoodTable.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ["order_detail_amount", "order_detail_oamount", "order_detail_diff", "order_detail_money"];
        sums = summaries(param, showSum);
        sums[0] = '单据合计';
        return sums;
    };
    DeliverGoodTable.prototype.sortChange = function (pager) {
        this.$emit('sortChange', pager);
    };
    DeliverGoodTable.prototype.showShopDetail = function (row) {
        this.mulShopList = JSON.parse(JSON.stringify(row.shop_items));
        this.$refs.mulShop.showRelease();
    };
    DeliverGoodTable.prototype.seeBindLicenses = function (row) {
        GLOBAL_VUE.$emit('addTab', {
            component: SeeBindLicenses,
            opener: this,
            title: '查看证照',
            showExist: true,
            name: 'goods-see-bind-license' + row.supplier_goods_id + 'goods_format_id' + row.goods_format_id + 'order_id' + this.detailData.order_id + 'order_detail_id' + row.order_detail_id,
            cprops: {
                from_page: 'deliver',
                order_id: this.detailData.order_id,
                order_detail_id: row.order_detail_id,
                goods_id: row.supplier_goods_id,
                goods_name: row.supplier_goods_name,
                goods_code: row.supplier_goods_code,
                goods_format_id: row.goods_format_id,
                goods_format_name: row.supplier_goods_format,
                is_edit_order_document: row.is_edit_order_document,
            }
        });
    };
    __decorate([
        Prop({
            type: Array,
            default: [],
        })
    ], DeliverGoodTable.prototype, "tableData", void 0);
    __decorate([
        Prop({
            default: function () { return ({}); },
        })
    ], DeliverGoodTable.prototype, "detailData", void 0);
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], DeliverGoodTable.prototype, "type", void 0);
    DeliverGoodTable = __decorate([
        Component({
            components: {
                "mul-shop-oamount": MulShopOamount,
                'select-stock-batch': SelectStockBatch,
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
                canSelectBatch: 'canSelectBatch',
            }), { orderHasMerge: function () {
                    var isStraight = this.detailData.logistics_type == this.eLogisticsType.Straight;
                    var isVirtualStraight = this.detailData.logistics_type == this.eLogisticsType.VirtualStraight;
                    var isDirect = this.detailData.logistics_type == this.eLogisticsType.Direct && this.detailData.depot_in_type == 1;
                    var isCustomer = this.detailData.from_system === EOrderFromSystem['客户系统'];
                    var hasMerge = (isStraight || isVirtualStraight || isDirect) && isCustomer;
                    return hasMerge;
                },
                through_is_show_uprice: function () {
                    var isVirtualStraight = [5].includes(this.detailData.logistics_type);
                    return (isVirtualStraight && this.detailData.vir_through_is_show_uprice == 1);
                } })
        })
    ], DeliverGoodTable);
    return DeliverGoodTable;
}(Vue));
export default DeliverGoodTable;
